import React, { Component } from 'react'

export default class Loading extends Component {
    componentDidMount = () => {
        let checkID = this.props.location.state;
        if (checkID == undefined) {
            window.location.replace('/loadingout')
        } else {
            // Data sudah di-set dari LoginPage, langsung redirect
            setTimeout(() => {
                window.location.replace('/home')
            }, 500);
        }
    }

    render() {
        return (
            <div id="spinner" className="loader-1 colorful center-object">
                <div className="dot" />
                <div className="dot" />
                <div className="dot" />
            </div>
        )
    }
}
